<template>
    <div class="window-wrapper window-client-check-error">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Не удалось отправить письмо по следующим email: {{getRecepients(letter.recepientList)}}.</div>
                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SendError1Window",
    props: ["letter"],
    methods: {
        closeWindow() {
            $('.window-client-check-error').removeClass('window-open');
            $('body').removeClass('blocked');
        },
        getRecepients(recepientList) {
            if (recepientList) {
                return recepientList.split(',').join(', ');
            }
            return "";
        }
    }
}
</script>

<style scoped>

</style>